import OpenQueryQuery from "./OpenQueryQuery-container";

export default OpenQueryQuery;